import isNil from 'lodash/isNil';

import { arrayIncludesFieldOfObject } from './arrayutils';
import { isNilOrEmpty } from './objectUtils';
import { LooseObject } from './types';

export interface Filter {
  name: string;
  field: string;
  items: string[];
}

/** An empty bound means "unbounded", which is why the range is not a plain pair of numbers. */
export interface FilterMinMax {
  min: number | '';
  max: number | '';
}

const OPEN_BOUND_LABEL = '…';

export const EURO_SUFFIX = ' €';

export const isMinMaxSet = (value: FilterMinMax | null): boolean =>
  !isNil(value) && (value.min !== '' || value.max !== '');

export const formatMinMax = (value: FilterMinMax | null, suffix: string): string => {
  if (isNil(value)) {
    return '';
  }
  const min = value.min === '' ? OPEN_BOUND_LABEL : String(value.min);
  const max = value.max === '' ? OPEN_BOUND_LABEL : String(value.max);
  return `${min} - ${max}${suffix}`;
};

export const toNonNegativeBound = (value: string): number | '' => {
  const bound = Number(value);
  if (value === '' || Number.isNaN(bound)) {
    return '';
  }
  return Math.max(0, bound);
};

export const isEntityInClassicFilters = (entity: LooseObject, filters: Filter[]) => {
  return !filters.some((filter) => filter.items.length > 0 && !isEntityInClassicFilter(entity, filter));
};

export const isEntityInClassicFilter = (entity: LooseObject, filter: Filter) => {
  return filter.items.length === 0 || arrayIncludesFieldOfObject(filter.items, filter.field, entity);
};

export const sortValuesByLabel = (values: { label: string; value: string }[]) => {
  values.sort((v1, v2) => (v1.label > v2.label ? 1 : -1));
};

export const updateFilters = (newFilter: Filter, existingFilters: Filter[]) => {
  if (isNilOrEmpty(existingFilters)) {
    return [newFilter];
  }
  const updatedFilters = existingFilters.reduce((newFilters, filter) => {
    if (filter.name === newFilter.name && !isNilOrEmpty(newFilter.items)) {
      newFilters.push(newFilter);
      return newFilters;
    }
    return newFilters;
  }, [] as Filter[]);

  return updatedFilters;
};
